import className from "classnames";
import { useDispatch } from "react-redux";
import Tabs from "components/UI/Tabs/Tabs";
import { Globals } from "utils/styleconfig";
import { useEffect, useState } from "react";
import Button from "components/UI/Button/Button";
import { RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { Link, useNavigate, useParams } from "react-router-dom"

import List from "components/List/List";
import EditAccount from "../EditAccount/EditAccount";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useGetAccountQuery } from "features/account/accountApiSlice";
import AccountExtensions from "../AccountExtensions/AccountExtensions";

const ViewAccount = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isEditVisible, setEditVisible] = useState(false);

  useEffect(() => {
    dispatch(setNavbarTitle("View Account"));
  }, [dispatch]);

  const { data: account } = useGetAccountQuery(params?.id);

  let accountBtnEl = null;

  const toggleEditVisibility = () => {
    setEditVisible(!isEditVisible); // Toggle visibility on button click
  };

  const onViewDevicesBtnHandler = () => {
    navigate(`/extensions/${params.id}/devices`);
  };

  const extensionData = [,
    { label: "Number", value: account?.number },
    { label: "Max Channels", value: account?.maxchannels },
    { label: "CPS", value: account?.cps },
    { label: "Allow Call Recording", value: account?.allow_call_recording ? 'Yes' : 'No' },
    { label: "Charge Per Min", value: account?.charge_per_min },
    { label: "Allow ip Management", value: account?.allow_ip_management ? 'Yes' : 'No' },
    { label: "Enabled", value: account?.enabled ? 'Yes' : 'No' },
    { label: "Account Type", value: account?.type },
    {
      label: "User",
      value: account?.user ? (
        <Link to={`/users/${account.user_id}`} style={{ color: Globals.colorPrimary, textDecoration: 'underline' }}>
          {account.user.firstname} {account.user.lastname}
        </Link>
      ) : 'N/A'
    },
    { label: "DID CID Translation", value: account?.did_cid_translaiion || 'N/A' },
    { label: "STD CID Translation", value: account?.std_cid_translaiion || 'N/A' }, ,
  ];

  const tabsData = [
    { key: "extensions", label: "Account Extension", content: <AccountExtensions label={label} /> },
  ];

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
          <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={extensionData} />

          <div>
            {/* Button to toggle visibility */}
            <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
              {isEditVisible ? (
                <RiCloseFill color={Globals.colorRed} size={30} />
              ) : (
                <>
                  <h3>Edit Account </h3>
                  <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                </>
              )}
            </Button>
          </div>
        </div>
        {/* <div>
          <button
            onClick={onViewDevicesBtnHandler}
            className={utilityStyles.btn}
          >
            <h3>View extension devices</h3>
            <RiArrowRightSLine color={Globals.colorDarkBlue} size={16} />
          </button>
        </div> */}
      </div>

      {/* Edit Account Component Start*/}
      {isEditVisible && (
        <EditAccount label={label} />)
      }

      <Tabs tabs={tabsData} />

    </>
  )
}

export default ViewAccount